import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const ChatbotWrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=Pacifico');
  @import url('https://fonts.googleapis.com/css?family=Sen');

  overflow: hidden;
  .App {
    height: 100%;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    background-color: transparent;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: black;
  }

  .App-link {
    color: #61dafb;
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
  }

  #root {
    height: 100%;
    overflow: hidden;
  }

  .col {
    position: inherit;
    height: 100%;
  }

  .col-image {
    padding-top: 60px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .col-chat {
    height: 100%;
  }

  @media (max-width: 767px) {
    .col-image {
      display: none;
    }
  }

  .content {
    height: 100%;
  }

  .ant-modal-mask,
  .modal-backdrop,
  .resume-modal-overlay,
  .ant-drawer-mask {
    background-color: #172b4dbd !important;
  }

  .ant-modal-content {
    border-radius: 20px !important;
    box-shadow: rgb(0 0 0 / 5%) 0px 3px 20px;
  }
`
